import { render, staticRenderFns } from "./customMenu.vue?vue&type=template&id=70bd120c&scoped=true"
import script from "./customMenu.vue?vue&type=script&lang=js"
export * from "./customMenu.vue?vue&type=script&lang=js"
import style0 from "./customMenu.vue?vue&type=style&index=0&id=70bd120c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd120c",
  null
  
)

export default component.exports